// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"164":"01660a17","268":"ea5c0e06","432":"310c028c","453":"68693753"}[chunkId] + ".chunk.js";
};